export default "__VITE_ASSET__BqE4vch0__"